/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IncidentInjuryType = {
    Abrasion: 'abrasion',
    Bruise: 'bruise',
    Burn: 'burn',
    Fracture: 'fracture',
    Laceration: 'laceration',
    SkinTear: 'skin_tear',
    SprainStrain: 'sprain_strain',
    Other: 'other\''
} as const;
export type IncidentInjuryType = typeof IncidentInjuryType[keyof typeof IncidentInjuryType];


export function IncidentInjuryTypeFromJSON(json: any): IncidentInjuryType {
    return IncidentInjuryTypeFromJSONTyped(json, false);
}

export function IncidentInjuryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentInjuryType {
    return json as IncidentInjuryType;
}

export function IncidentInjuryTypeToJSON(value?: IncidentInjuryType | null): any {
    return value as any;
}

